module.exports = __webpack_public_path__ + "static/media/img_04.be9a046c.jpg";